import React from 'react';
import Navbar from '../src/components/Navbar';
import Home from '../src/components/Home';
import Images from '../src/components/Images';
import Loader from '../src/components/Loader';
import { Route, Routes } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
       <Route path='/' exact element={<Home />} />
       <Route path='/images' exact element={<Images />} />
     </Routes>
    </>
  );
}

export default App;
